import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from "@angular/core";
import { Subscription } from "rxjs";
import { SOTService } from "../../services";

@Component({
  selector: "sot-processcard",
  templateUrl: "./processcard.component.html",
  styleUrls: ["./processcard.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProcessCardComponent {

  @Input() public amount: number;
  @Input() public limit: number;

  public get over_limit(): boolean {
    return this.amount > this.limit;
  }

  public basketSubscription: Subscription;

  constructor() {
  }

}
